import { CampingStation } from "use-smart-locks-shared";
import { useStation } from "../../shared/hooks/use-station";
import { useCampingStationSlug } from "./use-camping-station-slug";

export const useCampingStation = (): CampingStation => {
  const stationSlug = useCampingStationSlug();

  return useStation(stationSlug);
};
